import request from '@/utils/request'


// 查询招工订单信息列表
export function listOrder(query) {
  return request({
    url: '/order/order/list',
    method: 'get',
    params: query
  })
}

// 查询招工订单信息分页
export function pageOrder(query) {
  return request({
    url: '/order/order/page',
    method: 'get',
    params: query
  })
}

// 查询招工订单信息详细
export function getOrder(data) {
  return request({
    url: '/order/order/detail',
    method: 'get',
    params: data
  })
}

// 根据订单ID查询师傅信息列表
export function getOrderMasters(id) {
  return request({
    url: '/order/order/masters',
    method: 'get',
    params: { id }
  })
}

// 根据订单ID查询订单支付项列表
export function getOrderPaymentItems(id) {
  return request({
    url: '/order/order/payment-items',
    method: 'get',
    params: { id }
  })
}

// 根据订单ID查询支付记录列表
export function getOrderPaymentRecords(id) {
  return request({
    url: '/order/order/payment-records',
    method: 'get',
    params: { id }
  })
}

// 根据订单ID查询打卡记录列表
export function getOrderCheckRecords(id) {
  return request({
    url: '/order/order/check-records',
    method: 'get',
    params: { id }
  })
}

// 根据订单ID查询打赏/辅材列表
export function getOrderRewards(id) {
  return request({
    url: '/order/order/rewards',
    method: 'get',
    params: { id }
  })
}

// 根据订单ID查询加班申请记录列表
export function getOrderOvertimeRecords(id) {
  return request({
    url: '/order/order/overtime-records',
    method: 'get',
    params: { id }
  })
}

// 根据订单ID查询评价列表
export function getOrderComments(id) {
  return request({
    url: '/order/order/comments',
    method: 'get',
    params: { id }
  })
}

// 根据订单ID查询售后记录列表
export function getOrderAfterSales(id) {
  return request({
    url: '/order/order/after-sales',
    method: 'get',
    params: { id }
  })
}

// 新增招工订单信息
export function addOrder(data) {
  return request({
    url: '/order/order/add',
    method: 'post',
    data: data
  })
}

// 修改招工订单信息
export function updateOrder(data) {
  return request({
    url: '/order/order/edit',
    method: 'post',
    data: data
  })
}

// 开票
export function invoiceOrder(data) {
  return request({
    url: '/order/order/invoice',
    method: 'post',
    data: data
  })
}

// 删除招工订单信息
export function delOrder(data) {
  return request({
    url: '/order/order/delete',
    method: 'post',
    data: data
  })
}

// 后台手动新增招工订单（只读展示型：师傅端可见但不可抢、不可看详情）
export function manualAddOrder(data) {
  return request({
    url: '/order/order/manual-add',
    method: 'post',
    data: data
  })
}

// 后台手动编辑招工订单（仅业务字段）
export function manualEditOrder(data) {
  return request({
    url: '/order/order/manual-edit',
    method: 'post',
    data: data
  })
}

// 后台手动关闭/重开招工订单：action = close | reopen
export function manualChangeOrderStatus(data) {
  return request({
    url: '/order/order/manual-status',
    method: 'post',
    data: data
  })
}

// 手动推送订单（向符合条件的在线师傅 WebSocket 派单）
export function putOrder(query) {
  return request({
    url: '/order/order/putOrder',
    method: 'get',
    params: query
  })
}
